import React from 'react';

// Dev Blog 1 - What are Coding Bootcamps?
import codingBootcampsImg from '../images/blog/what-are-coding-bootcamps.png';
// Dev Blog 2 - How Bootcamps Boost Personality
import boostPersonalityImg from '../images/blog/how-bootcamps-boost-personality.png';
// Dev Blog 3 - Effective Peer Mentoring
import peerMentorImg from '../images/blog/effective-peer-mentor.png';
// Dev Blog 4 - Online Resources vs Coding Bootcamps
import onlineVsInPersonImg from '../images/blog/online-resources-vs-coding-bootcamps.png';
// Digital Blog 1 - Instagram Grid Layout
import creativeInstagramImg from '../images/blog/instagram-layouts/creative-instagram-grid-layouts.png';
import instagram_beautifulandyummy from '../images/blog/instagram-layouts/we3academy_gridexample_beautifulandyummy.jpg';
import instagram_cocacola from '../images/blog/instagram-layouts/we3academy_gridexample_cocacola.jpg';
import instagram_djtally from '../images/blog/instagram-layouts/we3academy_gridexample_djtally.jpg';
import instagram_ekkomedia from '../images/blog/instagram-layouts/we3academy_gridexample_ekkomedia.jpg';
import instagram_frooti from '../images/blog/instagram-layouts/we3academy_gridexample_frooti.jpg';
import instagram_joiknowshow from '../images/blog/instagram-layouts/we3academy_gridexample_joiknowshow.jpg';
import instagram_ladyaustin from '../images/blog/instagram-layouts/we3academy_gridexample_ladyaustin.jpg';
import instagram_personaljournalapp from '../images/blog/instagram-layouts/we3academy_gridexample_personaljournalapp.jpg';
import instagram_sabyasachi from '../images/blog/instagram-layouts/we3academy_gridexample_sabyasachi.jpg';
import instagram_sarahperetz from '../images/blog/instagram-layouts/we3academy_gridexample_sarahperetz.jpg';
import instagram_saxoneldridge from '../images/blog/instagram-layouts/we3academy_gridexample_saxoneldridge.jpg';
import instagram_sudikama from '../images/blog/instagram-layouts/we3academy_gridexample_sudikama.jpg';
import instagram_we3academy from '../images/blog/instagram-layouts/we3academy_gridexample_we3academy.jpg';
import instagram_we3academy1 from '../images/blog/instagram-layouts/we3academy_gridexample_we3academy1.jpg';
import instagram_we3solutions from '../images/blog/instagram-layouts/we3academy_gridexample_we3solutions.gif';
import instagram_we3solutions1 from '../images/blog/instagram-layouts/we3academy_gridexample_we3solutions1.gif';
// Digital Blog 2 - Content Strategy
import contentStrategyImg from '../images/blog/content-strategy/content-strategy.png';
import content_facebookImg from '../images/blog/content-strategy/facebook.png';
import content_instagramImg from '../images/blog/content-strategy/instagram.png';
import content_linkedInImg from '../images/blog/content-strategy/linkedin.png';
import content_twitterImg from '../images/blog/content-strategy/twitter.png';
// Digital Blog 3 - Earn Money Through Instagram
import earnMoneyThroughInsta from '../images/blog/how-to-earn-money-through-instagram.png';
// Career Blog 1 - LinkedIn
import linkedInImg from '../images/blog/linkedin.png';
// Career Blog 2 - Expand Professional Network
import professionalNetworkImg from '../images/blog/expand-professional-network-online.png';
// Career Blog 3 - How To Ace A Remote Interview
import remoteInterviewImg from '../images/blog/ace-remote-interview.png';
// Career Blog 4 - Build An Outstanding Portfolio
import outstandingPortfolio from '../images/blog/build-outstanding-portfolio.png';
// Career Blog 5 - 5 Ways To Stay Productive While Working From home
import stayProductiveRemote from '../images/blog/stay-productive-remote.png';

export const TargetLink = ({ children, href }) => (
  <a href={href} target="_blank" rel="noreferrer noopener">
    {children}
  </a>
);

const _blogTypes = {
  development: 'Full Stack Development',
  'digital-marketing': 'Digital Marketing',
  'career-development': 'Career Development'
};

const _featured = {
  main: {
    id: 'what-are-coding-bootcamps',
    type: 'development'
  },
  development: {
    id: 'effective-peer-mentor'
  },
  'digital-marketing': {
    id: 'earn-through-instagram'
  },
  'career-development': {
    id: 'stay-productive-remote'
  }
};

const _blogData = {
  'career-development': {
    'stay-productive-remote': {
      title: '5 Ways To Stay Productive While Working Remotely',
      seo: {
        description:
          'To stay productive while working remotely you will have to create a workplace environment that allows you to maintain balance between personal and work life. We have listed 5 ways that could help you set up a workplace environment and stay productive while completing your daily assignments.'
      },
      img: stayProductiveRemote,
      imgAlt: 'WE3 Academy | 5 Ways To Stay Productive While Working Remotely',
      date: 'Friday, October 2nd, 2020',
      fullDate: new Date(2020, 9, 2).toISOString(),
      tldr: (
        <span>
          To stay productive while working remotely you will have to create a
          workplace environment that allows you to maintain balance between
          personal and work life. We have listed{' '}
          <a href="#five-ways">5 ways to stay productive</a> while completing
          your daily assignments.
        </span>
      ),
      text: (
        <div>
          <p>
            After 4 months of lockdown, the process of unlock has been started
            all over the country. Offices are operating on 50% attendance rule
            while some are still working remotely. After spending time indoors
            for 6 months, people are yet finding it difficult to be productive
            while working remotely. One of the reasons behind it might be that
            we are still adjusting to this change. At a workplace we usually
            have the habit of reporting to our desks, but at home we find
            ourselves on the couches and kitchen tables, trying to complete our
            daily tasks, often without discipline.
          </p>
          <p>
            One of the best ways to keep yourself focused is to create a
            workplace environment that allows you to focus on your daily work
            tasks. We have listed 5 ways that could help you set up an office
            environment and stay productive while completing your daily
            assignments.
          </p>
          <h4 id="five-ways">
            5 Ways To Stay Productive While Working From Home
          </h4>
          <ol>
            <li>
              <h3>Designate a separate work space</h3>
              <p>
                Having a designated spot to work helps you stay focused and
                limits distractions. Arrange the elements you usually have on
                your office desk and set up a place where you could do your
                office work, specifically a room. It is not possible for
                everyone as every house is different. Well, in that case, even a
                small corner can prove to be fruitful if used in the best
                possible way.
              </p>
              <p>
                Set an office ambiance at your dedicated workplace. Turn on the
                lights, do not work in the dark, and avoid working on the couch,
                bed, and any place where you sleep or take rest. These things
                can subconsciously make you lazy and could affect your
                productivity.
              </p>
            </li>
            <li>
              <h3>Set a schedule</h3>
              <p>
                Plan your daily work schedule. Decide on hours you will be
                working and when you will be doing your household chores. Try
                and keep up with your regular office hours. Inform your
                co-workers about your schedule and plan your meetings
                accordingly.
              </p>
              <p>
                Planning your schedule won’t just do the work, you will have to
                adhere to it. Since you have access to work all time does not
                mean you need to go beyond your working hours. If you are taking
                random breaks and doing personal tasks during working hours, you
                may lose track of time and end up working little by little
                throughout the day, which might make you feel like you worked
                all day. Know when to stop and take scheduled breaks. This will
                help you maintain the balance between your work life and
                personal life.
              </p>
            </li>
            <li>
              <h3>Dress the part</h3>
              <p>
                Working remotely surely has its own perks. You get a privilege
                to work in whichever clothes you want. But do not stay in the
                same pajamas from last night. Instead, have a wholesome
                breakfast, take a shower, and wear something lively and bright.
                This will ensure that you are attentive and allow you to stay
                productive the whole day.
              </p>
            </li>
            <li>
              <h3>Listen to music</h3>
              <p>
                You must have heard about music therapy and how music helps you
                to stay in a good mood. Listening to{' '}
                <TargetLink href="https://timesofindia.indiatimes.com/life-style/relationships/is-listening-to-music-during-work-good-or-bad/photostory/67625228.cms?picid=67625364">
                  music while working
                </TargetLink>
                , channels your thought process allowing you to generate fresh
                ideas. It creates an environment which helps you concentrate on
                your tasks and eliminate the distractions. Listen to happy music
                or your favorite ones or the music that keeps you focused.
                However, listening to music while solving a problem or preparing
                reports might not be of much help. Listen to music only when it
                isn’t distracting you from your work.
              </p>
            </li>
            <li>
              <h3>Socialize</h3>
              <p>
                Socialize with people around you, or give a call to your
                co-workers or friends just like you do during your breaks in the
                office. It keeps the environment cheerful and helps you stay
                calm while working. Communication always helps in reducing
                stress and improves mental health which is the need of an hour
                as remote working can cause imbalance between our personal and
                work life.
              </p>
            </li>
          </ol>
          <p>
            Hope these tips will help you stay focused and perform better while
            working remotely.
          </p>
          <p>
            Interested to improve your time management skills to maintain
            work-life balance while working from home? Attend our free webinar
            <TargetLink href="https://we3academy.com/workshop/time-management">
              “Time Management While Working Remotely”
            </TargetLink>{' '}
            and we will guide through a few ways that will help you manage your
            time and maintain balance in your work life while working remotely.
          </p>
        </div>
      )
    },
    linkedin: {
      title: 'How To Use LinkedIn Effectively?',

      img: linkedInImg,
      imgAlt: 'WE3 Academy | Use LinkedIn Effectively',
      // author: "Rasika Pawar",
      date: 'Friday, March 28th, 2020',
      fullDate: new Date(2020, 2, 28).toISOString(),
      tldr:
        'LinkedIn is a social media platform with a focus on professional network building. In this article, we have listed a few tactics on how you can use your LinkedIn profile effectively for searching for a job and expanding your professional network.',
      text: (
        <div>
          <p>
            Many people say that LinkedIn is the best place for job recruiters
            and hiring managers and a good site to expand your professional
            network. But do you know why?
          </p>
          <p>
            LinkedIn is a social media platform with a focus on professional
            network building. The content and users of this platform are
            dignified and business oriented. Employers use it to search for
            ideal job candidates and professionals use it to meet like-minded
            people, build contacts in their industry and share their thoughts.
            This makes it different from other social networking sites.
          </p>
          <p>
            Just having an account on LinkedIn is not enough, you need to keep
            your profile updated since it helps to increase your visibility
            online and makes it easy for industry professionals, and potential
            employers to find you on LinkedIn. Your profile should speak about
            the values you can provide to your connections.
          </p>
          <p>
            Here are a few ways to help you make your LinkedIn profile look
            professional:
          </p>
          <ol>
            <li>
              <h3>Profile &amp; Headline:</h3>
              <p>
                Your profile picture and headline are the first impression to
                anyone viewing your profile. Choose a professionally clicked
                image &amp; write a headline that showcases your main skills.
                The words used in your headline act as keywords which makes it
                easy for employers and professional contacts to find you. If
                you're looking for a job, you can use "Actively looking" or
                "Currently looking for a __ role" and also add your main skill
                in the title as well.
              </p>
            </li>
            <li>
              <h3>Summary:</h3>
              <p>
                Write a profile summary that describes your current job title,
                experience and expertise well. Showcase your skills and a little
                of your personality in the profile summary. Think of this as
                your elevator pitch and make it look professionally appealing.
                When a recruiter or a professional contact lands on your
                profile, they will most likely read this section, make sure it’s
                written such that they would willing to connect and strike up a
                conversation with you.
              </p>
            </li>
            <li>
              <h3>Projects &amp; Other Sections:</h3>
              <p>
                Add your projects, education, skills, and known language with a
                detailed but concise description where needed. This will provide
                a precise understanding about your qualifications and skills to
                the visitors on your profile.
              </p>
            </li>
            <li>
              <h3>Resume:</h3>
              <p>
                Attach your resume or portfolio in the pdf format and mention
                your website or blog, if you have any. A resume looks consistent
                in pdf format and makes it easier for job recruiters to download
                and save it for future reference.
              </p>
            </li>
            <li>
              <h3>Recommendations and Endorsements:</h3>
              <p>
                Get recommendations and endorsements for your skills from your
                colleagues and employers. This adds credibility to your profile
                and creates a great impression to anyone looking to work with
                you.
              </p>
            </li>
          </ol>
          <p>
            Once you update your LinkedIn profile, you can start building
            connections using your LinkedIn account. If you're looking for a
            job, or wondering about the kind of work that is available in your
            field and city, you can head on to{' '}
            <a
              href="https://www.linkedin.com/jobs/"
              target="_blank"
              rel="noreferrer noopener"
            >
              LinkedIn Job Search
            </a>
            .
          </p>
          <p>
            But before you start with job search or expanding your professional
            network, take these tips listed below into consideration. They’ll
            help you make better use of the resources available on LinkedIn:{' '}
          </p>
          <ol>
            <li>
              <h4>Establish a relationship with industry professionals</h4>
              <p>
                Your primary goal on LinkedIn should be to expand your
                professional network. The more connections you have, the better
                your chances will be of finding someone to help with your job
                search. Make sure you only connect with people you know and are
                from your field. If you want, make a list of people from your
                industry, go over their profiles, and then decide if they are
                worth connecting with.
              </p>
            </li>
            <li>
              <h4>Engage with your connections</h4>
              <p>
                {' '}
                If you want to develop healthy professional relations, you’ll
                have to engage with your connections in some way. You can share
                an informative article to your network, offer advice or give
                them a suggestion, share, like and comment on their updates, ask
                or give a shout-out to your connections. LinkedIn has so many
                ways for you to engage with your connections. While doing so,
                remember to be friendly as well as keep things professional.
              </p>
            </li>
            <li>
              <h4>Join LinkedIn professional groups </h4>
              <p>
                Just as Facebook, we can create and join groups on LinkedIn.
                These groups are mainly for people from the same industry or for
                ones with similar professional interests. Joining these groups,
                help you expand your network, show your expertise and possibly
                connect you to your future boss or employers. Do not just join
                these groups, be proactive and take part in the discussions,
                answer the questions that come up, share informative articles,
                put your opinions, and offer advice in the group.
              </p>
            </li>
            <li>
              <h4>Research about the company and interviewer</h4>
              <p>
                Before going in for an interview, perform a detailed research
                about the company and hiring managers or interviewers. Follow
                the company’s page and learn about the company’s product or
                service, work culture, employees and achievements. Also find out
                about the employers or interviewers interests, skills, and
                achievements. You can use this information during your interview
                to create relatability and show your interest and enthusiasm for
                the company. If you wish to work for a certain company, you can
                follow them on LinkedIn and get regular updates about the new
                positions, products or services and news of the companies.
              </p>
            </li>
            <li>
              <h4>
                Let hiring managers know you're available for new job
                opportunities
              </h4>
              <p>
                If you are a fresher or an experienced person looking for job
                opportunities, you can announce that with a statement in your
                headline or profile summary. If you are a freelancer, you can
                write a headline to highlight if you’re available for new
                projects.
              </p>
            </li>
          </ol>
          <p>
            Use these tips and leverage your LinkedIn account to its fullest to
            search for good networking and professional opportunities.
          </p>
          <p>
            If you need help creating your resumes and building portfolios drop
            an email at{' '}
            <a href="mailto:info@we3academy.com">info@we3academy.com</a>
          </p>
        </div>
      )
    },
    'professional-network': {
      seo: {
        description:
          'Building professional relationships helps you get clients, connections and informs you about the latest developments in the industry. With the current COVID-19 pandemic, you might find it difficult to expand your network. This article lists certain ways to grow your professional network online.'
      },
      title: 'Expand Your Professional Network Online',
      img: professionalNetworkImg,
      imgAlt: 'WE3 Academy | Grow Your Professional Network Online',
      date: 'Monday, 01st June, 2020',
      fullDate: new Date(2020, 5, 1).toISOString(),
      tldr: (
        <span>
          Building professional relationships helps you get clients, connections
          and informs you about the latest developments in the industry. With
          the current COVID-19 pandemic, you might find it difficult to expand
          your network. This article lists certain ways to{' '}
          <a href="#build-network">
            build and grow your professional network online
          </a>
          .
        </span>
      ),
      text: (
        <div>
          <p>Before we dive into today’s topic, let’s first understand -</p>
          <h3 id="professional-network">What is Professional Networking?</h3>
          <p>
            <i>
              “Developing healthy and meaningful relationships with one another
              for career or business purposes is called professional
              networking”.
            </i>
          </p>
          <p>
            Professional contacts or connections help you solve work-related
            queries, get you potential clients, recommend other professional
            connections and keep you informed about the latest development in
            the industry and emerging career opportunities. Connecting with the
            right people and building a healthy professional relationship with
            them is so essential these days. A better way to do this is by{' '}
            <TargetLink href="https://www.instagram.com/p/CAEw77YABQ9/">
              attending career events
            </TargetLink>
            , job fairs, workshops, seminars, trade shows, exhibitions, events
            at workplace, and other social events.
          </p>
          <p>
            With the current situation of the coronavirus pandemic, everyone is
            staying at home and avoiding being in a crowd. Many social events
            have been postponed and cancelled at this time. If you think you are
            missing out on a lot of networking opportunities because of it, you
            might have to rethink about it after reading this article. With this
            article, we will be making you aware of the ways to build and expand
            your professional network online.
          </p>
          <p>Let’s get started:</p>
          <h3 id="build-network">
            Ways To Build And Expand Your Professional Network Online:
          </h3>

          <ol>
            <li>
              <h4>
                <TargetLink href="https://we3academy.com/social-media-marketing-course">
                  Gear Up Your Social Media Game
                </TargetLink>
              </h4>
              <p>
                We all know social networking sites like Facebook, Instagram,
                Twitter, LinkedIn, Pinterest, YouTube and many more were created
                with an aim to connect people online and share information with
                one another. People make friends, have a casual chat with each
                other, and share content on these sites. In the same way, you
                can use these sites to make professional connections, especially
                LinkedIn which is the best platform to find relevant and
                productive contacts. You could read{' '}
                <TargetLink href="https://we3academy.com/blog/career-development/linkedin">
                  “How to use LinkedIn effectively?”
                </TargetLink>{' '}
                to leverage your LinkedIn account for career enhancement.
              </p>

              <p>
                For the starters, you need to decide your niche and then provide
                your audience with the content they might be interested in.
                Share some useful information relevant to your industry, give
                tips to the newcomers, post your opinions on some facets of your
                field, host a live session from your account, and upload your
                projects, if you have any. This will help you to reach people
                with common interests as well as them to find you.{' '}
              </p>

              <p>
                Do some research about the companies and people you would like
                to connect and work with by exploring their social media
                accounts. This will give you an idea of their expertise,
                reputation in the market, and how to pitch them in the correct
                way. Even many recruiters review a candidate's social media
                profiles before deciding to hire them. Send them a connection
                request along with a personalised message. By sharing their
                posts, commenting on their posts, and attending their live
                sessions you can let them know that you share common interests.
              </p>

              <p>
                The best way to make productive connections is to join
                networking groups on social platforms like LinkedIn and
                Facebook. Join groups that match your interest and take part in
                the discussions and activities of those groups. Also, try to get
                to know the members of the groups individually by making a
                personal connection.
              </p>

              <p>
                Before you start socializing, think about which social platforms
                can help you best to find meaningful connections. For instance,
                if you are a photographer, artist or someone from the creative
                field you can opt for Instagram and Pinterest, to make generic
                connections you can use Facebook and Twitter, and to find people
                dealing in business you can socialize on LinkedIn. To know more
                about the type of active audience content shared on various
                social media platforms you can read our blog on{' '}
                <a
                  href="https://we3academy.com/blog/digital-marketing/content-strategy-social-media"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  “Content strategy for Instagram, Facebook, Twitter, and
                  LinkedIn”
                </a>
                .
              </p>
            </li>
            <li>
              <h4>
                <TargetLink href="https://www.instagram.com/p/B_MHc-ugpC6/">
                  Communicate Via Email
                </TargetLink>
              </h4>
              <p>
                Writing an email is one of the authentic and professional ways
                of connecting with people. Networking emails are meant to form
                new relationships so you should sound formal, friendly, and
                presentable in your email.
              </p>
              <p>
                Before you write a networking email, research about the people
                and the organizations you would like to connect with. Explore
                their social media accounts, company profile, and website to
                know about their accomplishments, nature of business, area of
                expertise, and a little bit about their personal life.
              </p>
              <p>
                While writing a networking email, keep in mind that the person
                you are sending this email is a busy person. Write a tailored,
                thoughtful, engaging but concise email. Professionals and
                experts are more interested in sharing their knowledge and
                giving out advice. Do not ask for any favors, instead ask for
                advice, solve your queries or appreciate some of their works or
                projects and then ask for a recommendation in the end.
              </p>
              <p>
                Use these tips every time you write a networking email and make
                great connections.
              </p>
            </li>
            <li>
              <h4>
                <TargetLink href="https://www.instagram.com/p/CBmnI8vgtH6/">
                  Host / Attend Webinars
                </TargetLink>
              </h4>
              <p>
                Webinars are the seminars, presentations, workshops, and events
                that are conducted on the web. A webinar can prove to be a great
                platform to meet like-minded people.
              </p>
              <p>
                If you have detailed knowledge about a particular thing and are
                capable of providing valuable content, then you should
                definitely conduct a webinar. Hosting webinars allow you to
                emerge as an expert in your field and you will be able to
                provide solutions to people’s queries. You can build a lot of
                connections and interact with your audience by sending them a
                request to share the screen with you.
              </p>
              <p>
                Conducting a seminar not only allows you to form new connections
                but also gives you a lot of branding opportunities. You promote
                your services or product in the middle or end of the webinar to
                get prospective clients or you can suggest a few useful
                references to the audience.
              </p>
              <p>
                Likewise attending a webinar also allows you to meet the
                professional and experts from the industry. You can ask the
                speaker to be in the video and discuss the topic together. This
                will help you to let the speaker know you share common interests
                and allow you to form a meaningful relationship with them.
                Interacting with other participants on social media platforms
                like Twitter and Facebook can be helpful in expanding your{' '}
                <a href="#professional-network">professional network</a>.
              </p>{' '}
            </li>
          </ol>
          <p>
            Now that you know how you can use these online resources, go ahead
            and use your quarantine time to establish deeper, strong, and
            meaningful professional relations.
          </p>
          <p>
            Networking online is quite convenient and easier than in the real
            world. If you want to improve your communication skills and learn
            how to present yourself at networking events we can help you with
            our{' '}
            <a
              href="https://we3academy.com/career-development-course"
              target="_blank"
              rel="noreferrer noopener"
            >
              career development course
            </a>
            .
          </p>
        </div>
      )
    },
    'remote-interview': {
      seo: {
        description:
          'Remote interviews are conducted on phone or via video call. How you prepare for remote interviews differs quite a bit from in-person ones. For jobseekers who are unaware of this interview method or are going to interview remotely for the first time, this will help prepare for remote interviews.'
      },
      title: 'How To Ace A Remote Interview?',
      img: remoteInterviewImg,
      imgAlt: 'WE3 Academy | Ace A Remote Interview',
      date: 'Tuesday, 09th June, 2020',
      fullDate: new Date(2020, 5, 9).toISOString(),
      tldr: (
        <span>
          Remote interviews are conducted on phone or via video call. How you
          prepare for remote interviews differs quite a bit from in-person ones.
          For jobseekers who are unaware of this interview method or are going
          to interview remotely for the first time, this article will help to{' '}
          <a href="#ace-remote-interview">prepare for remote interviews</a>.
        </span>
      ),
      text: (
        <div>
          <p>
            Around this time of the year, some of you are graduating and
            applying for jobs whereas some are searching for new employment
            opportunities. Given the current circumstances, where people are
            staying indoors and restrictions have been placed on transportation,
            retail, mass gathering, among other things, jobseekers are unable to
            attend in-person interviews and employers are facing difficulties
            conducting interviews.
          </p>
          <p>
            Considering this scenario, many recruiters, HR managers, and
            employers have adopted the remote interview methods where they
            conduct interviews on phone or via video call. Remote interviewing
            is not a new concept. It has been into practice in the industry for
            a quite long time, but, for some job seekers this might be a new
            experience.
          </p>
          <p>
            If you are one of them or are nervous about the remote interview
            situation, then you have come to the right place. In this article,
            we have listed a few ways which will help you ace your remote job
            interviews.
          </p>
          <h3 id="ace-remote-interview">How To Ace A Remote Interview?</h3>
          <p>
            We have made three sections of what you are supposed to do{' '}
            <a href="#a-day-before">a day before the interview</a>,{' '}
            <a href="#few-minutes-before">a few minutes before the interview</a>
            , and <a href="#during-the-interview">during the interview</a> for
            you to help in a better way.
          </p>
          <h3 id="a-day-before">A Day Before The Interview</h3>
          <ol>
            <li>
              <h4>Research About The Company</h4>
              <p>
                The first and foremost thing you should do after scoring an
                interview is to research about the company. Researching about
                the company is important for any kind of interview. Know about
                the background of the company you’ll be interviewing with,
                understand the nature of their services or products, and their
                customer base. Look for a few details about the interviewer,
                like their full name, designation and how long they have worked
                at the company you are interviewing for, so that you will be
                prepared for certain situations.
              </p>
            </li>
            <li>
              <h4>Draft Notes &amp; Questions For Interviewer</h4>
              <p>
                Based on your research,{' '}
                <TargetLink href="https://www.instagram.com/p/B9BEiJKgp75/">
                  draft a set of questions
                </TargetLink>{' '}
                to ask to the interviewer. These questions will help you better
                understand the company, company’s services or product, your job
                role, and the company’s work culture. Also, prepare your answers
                for a few possible questions that an interviewer might ask, so
                you won’t blank out.
              </p>
            </li>
            <li>
              <h4>Choose A Comfortable Spot For The Interview</h4>
              <p>
                Inform your family members or housemates in advance about the
                interview to ensure you won’t be interrupted by them. Make sure
                that the spot you choose has no noise distraction. If the
                interview is going to be over a video call, then plan your set
                up where the lighting is good, and ensure that there is nothing
                disturbing in the background. Put your phone on silent and turn
                off notification settings for the apps on your laptop just to
                avoid any distraction.
              </p>
            </li>
            <li>
              <h4>Test Your Connection &amp; Appliances</h4>
              <p>
                Do a test run to check your headphones, laptop, internet
                connection, phone connection, and camera to ensure that they all
                work properly and reduce the chances of technical issues during
                your interview. Download or visit video applications like{' '}
                <a
                  href="https://www.skype.com/en/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  skype
                </a>
                ,
                <a
                  href="https://meet.google.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  google meet
                </a>
                ,{' '}
                <a
                  href="https://hangouts.google.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  hangout
                </a>
                ,{' '}
                <a
                  href="https://zoom.us/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  zoom
                </a>
                , etc. recommended by the interviewer and explore it to make
                sure you know how to use it during the interview. Keep your
                laptop and phone charged.
              </p>
            </li>
            <li>
              <h4>Mock Interview</h4>
              <p>
                Ask a friend or a family member to call you via video and
                conduct a mock interview. You will be prepared to answer the
                possible questions and know how you look on video, so that you
                don’t get too self-conscious during the interview.
              </p>
            </li>
          </ol>
          <h3 id="few-minutes-before">A Few Minutes Before The Interview</h3>
          <ol>
            <li>
              <h4>Dress Appropriately</h4>
              <p>
                Though it is a remote interview and the interviewer will only be
                able to see your upper half, you should dress appropriately from
                head to toe. It will make you feel confident and look
                professional.
              </p>
            </li>
            <li>
              <h4>Keep Everything Ready</h4>
              <p>
                Give a final touch to your setup by keeping your resume, pen, a
                note pad, and necessary documents handy. Having a clutter free
                desktop screen would be great if you are asked to share your
                screen. Keep the important applications and documents on your
                desktop for easy access. To be on the safer side, keep your
                laptop on charge throughout the interview.
              </p>
            </li>
            <li>
              <h4>Be On Time</h4>
              <p>
                Open the video application or visit the invitation link sent by
                the interviewer a few minutes before the interview just to
                ensure that you do not arrive late. You know, sometimes it takes
                time to load a website or a page.
              </p>
            </li>
          </ol>
          <h3 id="during-the-interview">During The Interview</h3>
          <ol>
            <li>
              <h4>Have A Positive Approach</h4>
              <p>
                Create a positive aura from the start and keep yourself calm
                during the interview. Do not talk about any negative things. Be
                confident and show enthusiasm in your speech. The interviewer
                should know you are interested in the conversation and job role.
              </p>
            </li>
            <li>
              <h4>Ask Questions</h4>
              <p>
                Ask questions that you have prepared and resolve doubts when
                necessary. It shows that you are curious about the role and are
                genuinely interested in finding out more.
              </p>
            </li>
            <li>
              <h4>Be Calm While Facing Technical Issues</h4>
              <p>
                There might be a time when technology won’t be on your side.
                Hopefully that won’t happen. Sometimes there might be a power
                cut, internet issues or device issues. Do not panic and keep
                yourself calm. Give them alternate contact details or ask to
                reschedule the interview. The interviewer will understand your
                situation as these incidents are obscure.
              </p>
            </li>
          </ol>
          <p>
            Hope these few tips help you ace your remote interviews. Good Luck
            from{' '}
            <a
              href="https://we3academy.com/career-development-course"
              target="_blank"
              rel="noopener noreferrer"
            >
              WE3 Academy
            </a>{' '}
            for your future interviews!
          </p>
        </div>
      )
    },
    'outstanding-portfolio': {
      title: 'Build An Outstanding Portfolio',
      img: outstandingPortfolio,
      imgAlt: 'WE3 Academy | Build An Outstanding Portfolio',
      // author: "Rasika Pawar",
      date: 'Monday, August 17th, 2020',
      fullDate: new Date(2020, 7, 17).toISOString(),
      tldr: (
        <span>
          Building a portfolio is a great way of promoting your work and
          showcasing your success and abilities to the world. We have shared a
          few tips to help you{' '}
          <a href="#outstanding-portfolio">build an outstanding portfolio</a>{' '}
          that showcases your skills efficiently.
        </span>
      ),
      text: (
        <div>
          <p>
            Every time you apply for a job, you are asked to send your portfolio
            along with your{' '}
            <TargetLink href="https://www.instagram.com/p/B560EjRgLBQ/">
              resume
            </TargetLink>
            . Why? It gives the hiring managers a gist of your accomplishments,
            capabilities, and helps them to decide whether to call you for an
            interview or not. Creating a portfolio that displays your
            creativity, talent, and qualifications in the best manner should be
            your priority while searching for a job.
          </p>
          <p>
            You spend months, and sometimes years developing skills, and
            acquiring knowledge in your field but putting it down in a portfolio
            seems overwhelming. You need to spend a good amount of time crafting
            your portfolio if you want to stand out to the hiring managers. In
            the beginning, you may not get it right and may have a lot of
            questions. As you start crafting it, you will slowly find the best
            way to do it. In this blog post, we have shared a few tips to help
            you build an outstanding portfolio that showcases your skills
            efficiently.
          </p>
          <h3 id="outstanding-portfolio">
            How To Build An Outstanding Portfolio?
          </h3>
          <ol>
            <li>
              <h4>Draft A Plan For Your Portfolio</h4>
              <p>
                The first thing while crafting a portfolio is to think about the
                flow of information that needs to be put in. Decide what should
                go first and what to include later. Think about who is going to
                view your portfolio and what they would want to know and choose
                a design for the portfolio accordingly. A well structured
                portfolio holds the interest of the viewers. Your portfolio
                should convey a story of your professional accomplishments,
                skills, and experience.
              </p>
            </li>
            <li>
              <h4>Introduce Yourself Professionally</h4>
              <p>
                Have a summary in the beginning which includes your name,
                educational qualification, years of experience, and interests,
                in brief. Add your photograph before or after the introduction
                to make it look more professional. A well written introduction
                creates a good image of your personality in front of the
                viewers. You can also add your favorite quote that defines you
                well.
              </p>
            </li>
            <li>
              <h4>Choose Your Best Work</h4>
              <p>
                A portfolio is a perfect opportunity to showcase your
                professional talents and let the hiring managers know how you
                could be the best fit for the job role and be of value to a
                company. If you want to seize this opportunity, your portfolio
                should speak quality more than quantity. Do not just put up all
                of your projects, analyze all of your work and select the best
                ones out of it that features your accomplishments and skills
                effectively.
              </p>
              <p>
                Explain your projects with some text and a few images or videos.
                Talk about the goals that have been achieved from the project
                and your role in it. This tells the viewers why the project was
                a success and how you managed to achieve the goal. Make sure to
                update your portfolio every time you accomplish a new project as
                fresh and new work is more admired.
              </p>
            </li>
            <li>
              <h4>Keep It Simple</h4>
              <p>
                Make sure your portfolio is easy to navigate and access and keep
                the design clean. A simple portfolio structure will make it easy
                for the viewer to process the information.
              </p>
            </li>
            <li>
              <h4>Include Recommendations For Your Qualifications</h4>
              <p>
                Enlist your achievements, educational background, industry
                experience, skills, and current job role along with good
                recommendations for each, if possible. Recommendations from your
                professors, mentors or people you had worked with in the past,
                will make you seem trustworthy and reliable.
              </p>
            </li>
            <li>
              <h4>Use Good Quality Images &amp; Videos</h4>
              <p>
                Low-resolution and poorly lit photos or videos can have a bad
                impact in a portfolio. All your hard work you put into your
                projects will go in vain if it is not presented properly. Use
                high-resolution photos and quality videos with good lighting,
                use natural light when possible to highlight the important
                details.
              </p>
            </li>
            <li>
              <h4>Get A Second Set Of Eyes On Your Portfolio</h4>
              <p>
                Whether you are a professional or student, always take a second
                opinion on your portfolio before drafting a final copy. Take
                honest insights from your mentors, trusted colleagues, and
                friends. It will help you make essential edits in your portfolio
                and achieve the results you are looking for. A keen critical eye
                is a great way to know how your portfolio will be perceived in
                the real world.
              </p>
            </li>
            <li>
              <h4>Provide Your Contact Details </h4>
              <p>
                It is important to share your contact details like email and/or
                phone number. You should also consider including social media
                handles in your portfolio since your social profiles tell a lot
                about your personality which help recruiters or clients to
                decide whether you could be the best fit for the job role or
                project.
              </p>
            </li>
          </ol>
          <p>
            We hope you have learnt some useful ways to build an outstanding and
            creative portfolio through this blog. Use these tips to create a
            great first impression, promote your work and showcase your success
            and abilities to the world using your portfolio.
          </p>
          <p>
            If you need any further help creating your portfolio or presenting
            your career accomplishments,{' '}
            <a href="https://we3academy.com/career-development-course">
              checkout our career development course
            </a>
            .
          </p>
        </div>
      )
    }
  },
  'digital-marketing': {
    '10-creative-instagram-grid-layouts': {
      title: '10 Creative Instagram Grid Layouts',
      img: creativeInstagramImg,
      imgAlt: 'WE3 Academy | Social Media Courses in Mumbai',
      // author: "Rasika Pawar",
      date: 'Friday, January 25th 2020',
      fullDate: new Date(2020, 0, 25).toISOString(),
      tldr: (
        <span>
          When visitors land on your Instagram account a consistent and
          well-planned grid layout is what makes them want to engage. We’ve
          listed <a href="#grid-layouts">10 grid layouts</a> that will help
          enhance your visitors experience.
        </span>
      ),
      text: (
        <div>
          <p>
            Instagram is all about visuals! If you know how to create good
            visual content, you are more likely to grow a following on this
            platform.
          </p>
          <p>
            Posting photographs, videos, gifs, memes and motivational quotes at
            regular intervals gets the attention of users to your account and
            helps you gain followers. But what if there’s no consistency in
            uploading images or videos and when people go to your feed, they
            find it messy or inconsistent? You might lose some potential
            followers. To avoid such scenarios, you need to plan your Instagram
            grid carefully.
          </p>
          <p>Here's a short gif of what an Instagram grid looks like:</p>
          <a
            href="https://www.instagram.com/we3solutions"
            target="_blank"
            rel="noreferrer noopener"
          >
            <img
              className="instagram-screenshot"
              src={instagram_we3solutions}
              alt="Instagram @we3solutions"
            />
          </a>
          <p>
            Before creating an Instagram grid, let’s go over a few essential
            elements that make an amazing Instagram grid:
          </p>
          <ol>
            <li>
              <h3>Enticing Theme</h3>
              <p>
                First and foremost you need to decide on a theme for your
                account. A theme is an idea or a concept. It consists of having
                a colour scheme and tone set for your Instagram account that
                defines the niche and core values of your brand. The more
                pleasant and relevant your theme is to your audience, the
                greater the amount of engagement generated.
              </p>
            </li>
            <li>
              <h3>Images And Video</h3>
              <p>
                Once you decide on a theme, your next step is to create high
                quality images and well scripted videos accordingly. Use the
                color scheme and content tone as decided. Put some intriguing
                elements in your images and videos. A user on Instagram will
                typically spend 3 seconds on each post, your content needs to be
                captivating enough to make your audience engage with your posts.
                No one wants to look at plain or dull things.
              </p>
            </li>
            <li>
              <h3>Consistency</h3>
              <p>
                For creating a great Instagram grid, consistency is the key. You
                need to be consistent about the colors, illustrations, audio,
                and post sizes you use for all of your instagram posts. Being
                consistent with your content helps people recognize your brand
                when they see your posts.
              </p>
            </li>
            <li>
              <h3>Grid Layout</h3>
              <p>
                Now that you have your content ready, you will have to decide on
                how to post your content, on which date you’ll be posting, and{' '}
                <a
                  href="https://we3academy.com/blog/digital-marketing/content-strategy-social-media"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  what you will be posting
                </a>{' '}
                on the decided dates. This makes your grid look professional,
                and creates a nice flow between posts. This flow between the
                posts is known as{' '}
                <a href="#grid-layouts">
                  <em>“Grid Layout”</em>
                </a>
                . Having a well planned grid layout creates a fun experience for
                the users while scrolling your Instagram feed.
              </p>
              <p>
                Think about these four elements before creating your Instagram
                grid. Research &amp; refer to Instagram accounts of popular
                brands or brands similar to yours and start building your own
                ideas.
              </p>
            </li>
          </ol>
          <p>
            To make it easy for you to decide on a grid layout we have listed
            below 10 creative Instagram grid layouts.
          </p>
          <h3 id="grid-layouts">10 Creative Instagram Grid Layouts:</h3>
          <ol>
            <li>
              <h3>Squares</h3>
              <p>
                One of the simplest ways to maintain your Instagram grid is to
                post your images and videos with the same color scheme or same
                filter.
              </p>
              <p>
                Here’s how{' '}
                <a
                  href="https://www.instagram.com/cocacola/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @cocacola
                </a>{' '}
                and{' '}
                <a
                  href="https://www.instagram.com/thefrootilife/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @thefrootilife
                </a>{' '}
                used the square grid layout to depict their brand’s core values
                and theme.
              </p>
              <img
                className="instagram-screenshot"
                src={instagram_cocacola}
                alt="Instagram @cocacola"
              />
              <img
                className="instagram-screenshot"
                src={instagram_frooti}
                alt="Instagram @thefrootilife"
              />
            </li>
            <li>
              <h3>Borders</h3>
              <p>
                Choose a color and add borders of that color to your image. You
                can either put borders on all the sides, at the top and bottom
                or on the left and right side of the image.
              </p>
              <p>
                The color of the border could be your brand colors or simply
                white or black just like how{' '}
                <a
                  href="https://www.instagram.com/sudikama/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @sudikama
                </a>
                ,{' '}
                <a
                  href="https://www.instagram.com/lady.austin/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @lady.austin
                </a>
                , and{' '}
                <a
                  href="https://www.instagram.com/beautifulandyummy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @beautifulandyummy
                </a>{' '}
                did for their Instagram grid.
              </p>
              <img
                className="instagram-screenshot"
                src={instagram_sudikama}
                alt="Instagram @sudikama"
              />
              <img
                className="instagram-screenshot"
                src={instagram_ladyaustin}
                alt="Instagram @lady.austin"
              />
              <img
                className="instagram-screenshot"
                src={instagram_beautifulandyummy}
                alt="Instagram @beautifulandyummy"
              />
            </li>
            <li>
              <h3>Puzzle</h3>
              <p>
                Break an image in three, six, nine or even more squares but it
                should be a multiple of 3. Upload those squares one by one and
                let your audience wonder what exactly you are trying to convey.
                It will look like an unsolved puzzle to them and will arouse
                their interest in your account. Once you upload the last square,
                your feed will look like a solved Jigsaw Puzzle.
              </p>
              <p>
                Here’s a puzzle layout from{' '}
                <a
                  href="https://www.instagram.com/we3solutions/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @we3solutions
                </a>{' '}
                to give you a clear understanding of this grid layout pattern.
              </p>
              <p>
                You could tell a story with a puzzle layout. This kind of grid
                layout takes a lot of effort but if you do it right, it might
                get you a good amount of engagements.
              </p>
              <a
                href="https://www.instagram.com/we3solutions"
                target="_blank"
                rel="noreferrer noopener"
              >
                <img
                  className="instagram-screenshot"
                  src={instagram_we3solutions1}
                  alt="Instagram @we3solutions"
                />{' '}
              </a>
            </li>
            <li>
              <h3>Checkerboard / Tiles</h3>
              <p>
                You all must have seen the board used for playing checkers or
                chess, where two colors are placed alternately. The checkerboard
                grid layout is adapted from this game and is also known as{' '}
                <em>“Tiles”</em>.
              </p>
              <p>
                Here's an example from{' '}
                <a
                  href="https://www.instagram.com/we3academy/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @we3academy
                </a>{' '}
                of the checkerboard / tile layout where a dark overlay image
                post with text is paired with a white background image with an
                illustration and text.
              </p>
              <img
                className="instagram-screenshot"
                src={instagram_we3academy}
                alt="Instagram @we3academy"
              />
            </li>
            <li>
              <h3>Vertical Line / Columns</h3>
              <p>
                Another basic grid layout pattern is Vertical Line where two of
                the columns have similar color or concept and the other column
                has a different one.
              </p>
              <p>
                Let’s have a look at how{' '}
                <a
                  href="https://www.instagram.com/sabyasachiofficial/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @sabyasachiofficial
                </a>{' '}
                and{' '}
                <a
                  href="https://www.instagram.com/joi.knows.how/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @joi.knows.how
                </a>{' '}
                arranged their instagram grid.
              </p>
              <img
                className="instagram-screenshot"
                src={instagram_sabyasachi}
                alt="Instagram @sabyasachiofficial"
              />
              <img
                className="instagram-screenshot"
                src={instagram_joiknowshow}
                alt="Instagram @joi.knows.how"
              />
            </li>
            <li>
              <h3>Horizontal Line / Rows</h3>
              <p>
                Another way to make your grid look consistent is to fill each
                row with three images or videos or a combination of both. These
                posts should resemble each other in some way.
              </p>
              <p>
                <a
                  href="https://www.instagram.com/personaljournalapp/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Personal Journal
                </a>{' '}
                is an app to record your daily activities and thoughts just like
                a diary. They've arranged their Instagram grid using horizontal
                line grid pattern to represent the concept of their app.
              </p>
              <img
                className="instagram-screenshot"
                src={instagram_personaljournalapp}
                alt="Instagram @personaljournalapp"
              />
            </li>
            <li>
              <h3>Rainbow</h3>
              <p>
                If you do not want to stick to a certain color scheme or a
                pattern then there is a colourful way to create a visually
                pleasing Instagram grid. It is called rainbow feed which is
                created using various colors and gives an experience of a
                rainbow while scrolling through the Instagram feed.
              </p>
              <p>
                Maintaining a rainbow feed really takes a lot of effort but{' '}
                <a
                  href="https://www.instagram.com/sarah_peretz/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @sarah_peretz
                </a>{' '}
                just knows how to slay at it. Sarah is one of the popular
                Instagram influencers. Look how beautifully she has arranged all
                of her images and videos to fit into the rainbow theme.
              </p>
              <img
                className="instagram-screenshot"
                src={instagram_sarahperetz}
                alt="Instagram @sarah_peretz"
              />
            </li>
            <li>
              <h3>Diagonal</h3>
              <p>
                Here, we have another simple yet attractive grid layout for you.
                It is called a diagonal grid layout.
              </p>
              <p>
                For this, you just need to arrange posts with similar content in
                a diagonal line as shown in the below image.{' '}
              </p>
              <img
                className="instagram-screenshot"
                src={instagram_we3academy1}
                alt="Instagram @we3academy"
              />
              <p>
                This screenshot is of{' '}
                <a
                  href="https://we3academy.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  WE3 Academy
                </a>{' '}
                instagram page,{' '}
                <a
                  href="https://instagram.com/we3academy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @we3academy
                </a>
                , where the course promotion posts are placed diagonally with a
                blue background and the tips and facts posts with white
                background around them.
              </p>
            </li>
            <li>
              <h3>Videos</h3>
              <p>
                If you are a vlogger, a video creator or a brand whose focus is
                on creating videos, then this one's for you. Here's two ideas to
                make your instagram feed look interesting and consistent:
              </p>
              <ul>
                <li>
                  <p>
                    You can do it like{' '}
                    <a
                      href="https://www.instagram.com/saxoneldridge/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      @saxoneldridge
                    </a>{' '}
                    where only videos are being posted and no images nor
                    illustrations.
                  </p>
                  <img
                    className="instagram-screenshot"
                    src={instagram_saxoneldridge}
                    alt="Instagram @saxoneldridge"
                  />
                </li>
                <li>
                  <p>
                    You can choose one of the grid layout mentioned in this
                    article and arrange the videos accordingly just like{' '}
                    <a
                      href="https://www.instagram.com/djtally"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      @djtally
                    </a>
                    .
                  </p>
                  <img
                    className="instagram-screenshot"
                    src={instagram_djtally}
                    alt="Instagram @djtally"
                  />
                </li>
              </ul>
            </li>
            <li>
              <h3>Mixed Feed</h3>
              <p>
                There’s no such rule that you have to follow the same grid
                layouts forever. You can use a variety of grid layouts and
                switch from one layout to another.
              </p>
              <p>
                You could also try a combination of two or more layouts and
                create a new layout for your account like how{' '}
                <a
                  href="https://www.instagram.com/ekkomedia/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  @ekkomedia
                </a>{' '}
                used a combination of borders, puzzle, and only video layout.
              </p>
              <img
                className="instagram-screenshot"
                src={instagram_ekkomedia}
                alt="Instagram @ekkomedia"
              />
              <p>
                This could be a great way to plan your grid by using two or more
                grid patterns. But make a note to keep the chosen layout
                consistent for a certain time period, then move to another
                layout if you want.
              </p>
            </li>
          </ol>
          <p>
            Now that you know what an Instagram grid is and what the various
            types of grid layout are, we hope this will inspire you to create
            your own creative Instagram feed. Go! Hurry up. Choose a perfect
            theme for your instagram account and enhance your visitors
            experience.
          </p>
        </div>
      )
    },
    'content-strategy-social-media': {
      title: 'Content Strategy For Instagram, Facebook, Twitter, & LinkedIn',
      img: contentStrategyImg,
      imgAlt: 'WE3 Academy | Social Media Courses in Mumbai',
      // author: "Rasika Pawar",
      date: 'Thursday, March 5th 2020',
      fullDate: new Date(2020, 2, 5).toISOString(),
      tldr: (
        <span>
          This blog will give you an idea about how the 4 major social media
          platforms: <a href="#facebook">Facebook</a>,{' '}
          <a href="#instagram">Instagram</a>, <a href="#twitter">Twitter</a>,
          and <a href="#linkedin">LinkedIn</a>, work, what type of content is
          consumed by the audience of these platforms and how you can make the
          most use of it to market your brand online.
        </span>
      ),
      text: (
        <div>
          <p>
            It has become essential for businesses to have a presence on social
            media. It helps you engage with connections, customers, and
            prospective customers and create a personal touch with them.
          </p>
          <p>
            As a brand, your first step should be to select suitable social
            media platforms that will help you reach the right audience. You’re
            not required to have a presence on every platform, instead aim to
            have a strong presence on the platforms that will guarantee you a
            loyal customer base. For this, you need to have an extensive{' '}
            <TargetLink href="https://we3academy.com/social-media-marketing-course">
              understanding of how each platform works
            </TargetLink>
            , what type of audience is present on each and what type of{' '}
            <TargetLink href="https://www.instagram.com/p/B6XNGpQgB6p/">
              content
            </TargetLink>{' '}
            users share &amp; search on each platform.
          </p>
          <p>
            In this article, we’ll break down the 4 major social media
            platforms: <a href="#facebook">Facebook</a>,{' '}
            <a href="#instagram">Instagram</a>, <a href="#twitter">Twitter</a>,
            and <a href="#linkedin">LinkedIn</a> and help you understand how
            they work, what type of content is consumed by the audience of these
            platforms and how you can make the most use of it to market your
            brand online.
          </p>
          <ol>
            <li>
              <h3 id="instagram">
                <TargetLink href="https://www.instagram.com/we3academy/">
                  Instagram
                </TargetLink>
              </h3>
              <img
                className="content-social-logo"
                src={content_instagramImg}
                alt="Instagram"
              />
              <p>
                Instagram has a high number of users interested in Fashion,
                Trends, Lifestyle, Celebrity Gossip, and Entertainment. If you
                have a brand which wants to use Instagram as a marketing
                platform, you should be aware of the latest trends in the
                industry.
              </p>
              <p>
                Instagrammers tend to consume content which is crisp, humourous,
                trendy, and has high resolution pictures. Creative photos and
                videos with{' '}
                <TargetLink href="https://www.instagram.com/p/B_eJA2RgrDR/">
                  intriguing captions
                </TargetLink>{' '}
                is the mantra to gain engagement on Instagram. Instagram also
                allows you to post on your Facebook and Twitter accounts at the
                same time which is useful if you want to share the same photos
                across multiple platforms. Include new trends, memes,
                inspirational quotes, tips, facts, quiz, behind the scenes,
                making videos, and contests in your posting strategy along with
                advertisements based on your offers, discounts, and services.
              </p>
              <p>
                Instagram stories also play a vital role in boosting your
                engagement with your audience. Encourage your audience to
                interact with you by conducting polling activities, asking
                questions, conducting contests and giveaways and posting behind
                the scenes on your story to attract new followers and retain the
                existing ones. You can also cover an{' '}
                <TargetLink href="https://www.instagram.com/p/CBmnI8vgtH6/">
                  event live
                </TargetLink>{' '}
                or interact with your audience through live chats. The more you
                interact with your audience and create a personal touch with
                them, the more likely you are to excel on{' '}
                <TargetLink href="https://we3academy.com/blog/digital-marketing/10-creative-instagram-grid-layouts">
                  instagram
                </TargetLink>
                .
              </p>
              <p>
                While other social media platforms allow you to attach website
                or blog links to your posts, Instagram does not support link
                sharing directly in posts. Basic users can add links in their
                bio whereas verified users, and accounts having 10,000 or more
                followers, can post links in their Instagram Stories. Just like
                Facebook, Instagram allows users to tag other users, like,
                comment on the posts, or direct message each other.
              </p>
              <p>
                <h4>Quick Tip:</h4>
              </p>
              <p>
                <em>Target audience:</em> 14 - 30 years
              </p>
              <p>
                <em>Character limit for post:</em> 2,200 characters{' '}
              </p>
              <p>
                <em>
                  <TargetLink href="https://www.instagram.com/p/B74_DP0AXQs/">
                    Hashtag
                  </TargetLink>{' '}
                  limit:
                </em>{' '}
                30 hashtags{' '}
                <i>
                  (you can use more than 30 hashtags but you won’t be able to
                  promote your posts if you do)
                </i>
              </p>
            </li>
            <li>
              <h3 id="facebook">
                <TargetLink href="https://www.facebook.com/we3academy">
                  Facebook
                </TargetLink>
              </h3>
              <img
                className="content-social-logo"
                src={content_facebookImg}
                alt="facebook"
              />
              <p>
                Facebook can be the best platform for a business that wants to
                reach out to the audience of all age groups and with different
                opinions. People use Facebook to stay connected with their
                family and friends and make new friends and share articles,
                photographs, videos with their own opinions and ideas in the
                caption. People are likely to tag other users, like, comment on
                the posts, and message each other to stay in touch.
              </p>
              <p>
                The type of content shared and read on Facebook is emotionally
                driven. For a strong presence on Facebook, post updates at
                regular intervals, and create content that connects with
                people’s emotions. Include memes, inspirational quotes, tips,
                facts, quiz, behind the scenes, making videos, testimonials, and
                contests in your posting strategy along with advertisements
                based on your offers, discounts, and services. If your audience
                finds your post intriguing they are likely to engage with your
                brand and post feedback on your profile. The more people are
                engaging, the more frequently you’ll appear in others timelines
                making it easier to get discovered organically.
              </p>
              <p>
                A good amount of traffic can be generated to your website or
                blog by sharing links with posts and in your bio.
              </p>
              <p>
                <h4>Quick Tip:</h4>
              </p>
              <p>
                <em>Target audience:</em> 18 - 60 years
              </p>
              <p>
                <em>Character limit for post:</em> 63,206 characters
              </p>
            </li>
            <li>
              <h3 id="twitter">
                <TargetLink href="https://twitter.com/we3academy/">
                  Twitter
                </TargetLink>
              </h3>
              <img
                className="content-social-logo"
                src={content_twitterImg}
                alt="twitter"
              />
              <p>
                Keeping pace with what is happening around the world has become
                easy with Twitter. People often look at it as a pool of
                information. They use it to stay updated and get a quicker view
                of the trending news or topic. Unlike other social media
                platforms, Twitter allows its users to write a caption or an
                update upto 280 characters or less.
              </p>
              <p>
                That means you have to be interesting, and informative at the
                same time within a few words. It seems a little difficult but
                with a proper planning and by adopting a habit of tweeting
                regularly you can do it correctly. If your content is lengthy
                and enticing, you can use a twitter thread. Twitter thread is a
                new feature introduced by twitter in 2019, where you can connect
                multiple tweets together by adding a tweet to another tweet.
              </p>
              <p>
                Twitter is a great platform to engage with your potential
                audience. Photos, polls, gifs, short videos, quotes, statistics,
                or questions used appropriately with relevant and trending
                hashtags guarantees higher amount of engagement. People often
                use specific hashtags to search for their favorite topic. Do a
                research on what your target audience search for to make sure
                your posts are read by the right people.
              </p>
              <p>
                You can tag companies or your customers in your tweets, reply to
                customers queries with a retweet or via direct messages, take
                part in discussions, and retweet the positive feedback. Support
                your tweets with some good blog links, website links, or new
                articles to make it sound more reliable. Likewise, if you add
                links of your official website or blog to your tweets you are
                likely to generate traffic to your website or blog.
              </p>
              <p>
                <h4>Quick Tip:</h4>
              </p>
              <p>
                <em>Target audience:</em> 18 - 50 years
              </p>
              <p>
                <em>Character limit for post:</em> 280 characters
              </p>
            </li>
            <li>
              <h3 id="linkedin">
                <TargetLink href="https://www.linkedin.com/company/we3academy/">
                  LinkedIn
                </TargetLink>
              </h3>
              <img
                className="content-social-logo"
                src={content_linkedInImg}
                alt="linkedIn"
              />
              <p>
                People looking out for professional services, or companies
                involved in B2B service, trust LinkedIn to build their brand and
                grow a customer base. The emphasis is more on career-related,
                professional networking, business, economics, and other
                professional services.
              </p>
              <p>
                Out of all the social media platforms, LinkedIn is the one where
                you are supposed to be professional and specific about your
                content as it’s niche is directed to businesses and
                professionals. You shouldn’t randomly post your thoughts and
                opinions here like you do on other social media accounts. If you
                are sharing an article or posting your thoughts, make sure they
                are about things relevant to the career you are in.
              </p>
              <p>
                Your business profile should talk about your business, services,
                and industry related topics. You can use photographs, videos,
                and PDF files to create an update on your business profile and
                message your potential audience or post a comment on an update
                of a reliable source. Another way by which you can make
                connections is by joining LinkedIn groups of similar interests.
                Take part in the group discussions, post about your services,
                ask questions and support other businesses. This could be the
                perfect way to showcase your expertise, build contacts and meet
                professionals from your industry.
              </p>
              <p>
                With features like LinkedIn Pulse, Company Pages, InMail,
                Groups, and “Get Introduced” and the ability to see who’s viewed
                your personal profile, this platform makes it easy for
                recruiters to search desired candidates and businesses to find
                their potential customers.
              </p>
              <p>
                Recently, LinkedIn released a new feature similar to Facebook
                events where you can promote a business event and invite people
                to attend your event. If used correctly this feature may help
                you to market your event and build more connections in the
                process.
              </p>
              <p>
                <h4>Quick Tip:</h4>
              </p>
              <p>
                <em>Target audience:</em> B2B, decision makers and influencers
              </p>
              <p>
                <em>Character limit for post:</em> 1300 characters
              </p>
            </li>
          </ol>
          <p>
            Now that you know how these 4 platforms work, be smart and choose
            the ideal ones for your brand and spend some quality time to make
            your social profiles appealing.
          </p>
        </div>
      )
    },
    'earn-through-instagram': {
      title: 'How To Earn Money Through Instagram',
      img: earnMoneyThroughInsta,
      imgAlt: 'WE3 Academy | How To Earn Money Through Instagram',
      // author: "Rasika Pawar",
      date: 'Thursday, January 5th 2021',
      fullDate: new Date(2021, 0, 5).toISOString(),
      tldr: (
        <span>
          From a photo sharing app to being a platform for making money,
          Instagram has evolved a lot in the last few years. Everyone wants to
          know ways of making money on Instagram. In this article, we have
          listed{' '}
          <a href="#three-ways-to-earn-through-insta">
            three major ways of earning through Instagram
          </a>
          .
        </span>
      ),
      text: (
        <div>
          <p>
            Instagram has evolved a lot in the span of the last few years. From
            a photo sharing app, it has become an important aspect of online
            marketing. While brands leverage it to sell their products, there
            are Instagrammers who earn and make a living using Instagram.
          </p>
          <p>
            Now, you might have wondered how these people earn money through
            Instagram. Will I be able to make money through instagram as well?
            To answer these questions, we have listed below 3 ways to earn
            through Instagram.
          </p>
          <h3 id="three-ways-to-earn-through-insta">
            3 Strategies To Earn Through Instagram:
          </h3>
          <div>
            <div style={{ paddingTop: '10px' }}>
              <a href="#become-an-influencer">Become An Influencer</a>
            </div>
            <div style={{ paddingTop: '10px' }}>
              <a href="#become-an-affiliate-marketer">
                Become An Affiliate Marketer
              </a>
            </div>
            <div style={{ paddingTop: '10px' }}>
              <a href="#become-an-entrepreneur">Become An Entrepreneur</a>
            </div>
          </div>
          <br />
          <ol>
            <li>
              <h4 id="become-an-influencer">Become An Influencer</h4>
              <p>
                First, let’s understand who is an influencer and what he / she /
                they do:
              </p>
              <p>
                <i>
                  “An <strong>Influencer</strong> is someone who has built a
                  huge but trustworthy audience base on any social platform like
                  YouTube, Instagram, Facebook, and can influence them to buy a
                  product or service and follow any trend”.
                </i>
              </p>
              <p>
                Companies approach the influencers who have a quality
                engagement, for promoting their brand. In return, the
                influencers earn a revenue based on the content and reach of the
                account. These promotional posts are called{' '}
                <strong>sponsored posts</strong>. Top influencers earn around
                thousand dollars or more for each collaboration and get to work
                with renowned brands.
              </p>
              <p>
                The influencers’ lifestyle might seem fascinating but it
                requires a lot of effort to maintain it. Sometimes brands
                approach you and sometimes you have to pitch brands for
                collaborations. An influencer has to be creative and create
                content on a regular basis that drives attention of their
                audience. To develop strong content, an influencer keeps a track
                of their followers - their interests, what they like to see and
                explore on a particular platform, demographics, and plan the
                content accordingly.
              </p>
              <p>
                If you believe you have what it takes to be an Influencer, here
                are a few things you should know before starting as an
                Influencer:
              </p>
              <ol type="a">
                <li>
                  <strong>Choose a niche</strong>
                  <p>
                    Analyze what are your best skills and create content
                    accordingly. For instance, if you have a good fashion sense,
                    start by posting pictures of your best outfits or videos of
                    fashion hacks. Once you get into the process, you will keep
                    getting better at it and find new ideas to create
                    influential content.
                  </p>
                </li>
                <li>
                  <strong> Build a trustworthy audience base</strong>
                  <p>
                    As you decide your niche, define what kind of audience you
                    would like to attract and understand their taste,
                    preferences and interests. Post content accordingly and
                    maintain consistency. Your content should help and inspire
                    people if you want them to like and trust you. This will
                    surely help you build a noteworthy follower base.
                  </p>
                  <p>
                    People have this assumption that having 10,000 followers is
                    important to become an influencer. Having 10,000 followers
                    surely has its own perks like the "Swipe Up" feature for
                    instagram stories. Some accounts also get verified ticks on
                    their profile but it is not a necessity. Even if you have a
                    minimum following of a 1,000 followers, you can start as a
                    micro influencer.
                  </p>
                </li>
                <li>
                  <strong>Collaborate with brands</strong>
                  <p>
                    In the beginning, you will have to pitch the brands
                    yourself. Find brands that suit your niche, and that you’re
                    inspired by. Approach them and tell them what you can bring
                    to the table, what your USP is, and how you can influence
                    the audience. Signing up on some influencer marketing
                    platforms like{' '}
                    <TargetLink href="https://www.plixxo.com/">
                      Plixxo
                    </TargetLink>
                    ,{' '}
                    <TargetLink href="https://www.opa.marketing/">
                      OPA
                    </TargetLink>{' '}
                    and{' '}
                    <TargetLink href="https://www.influencer.in/">
                      Influencer.in
                    </TargetLink>
                    , can help brands find you. Make sure to put up your contact
                    information in your Instagram bio and switch your Instagram
                    profile to creators mode. It makes your profile more visible
                    to potential audience as well as brands.
                  </p>
                </li>
                <li>
                  <strong>Use Hashtags when it is a sponsored post</strong>
                  <p>
                    {' '}
                    Use hashtags like #sponsored #ad #promotion or hashtags
                    preferred by the brand you are collaborating with to let
                    people know it’s a sponsored post.
                  </p>
                </li>
              </ol>
            </li>
            <li>
              <h4 id="become-an-affiliate-marketer">
                Become An Affiliate Marketer
              </h4>
              <p>
                Another great strategy to earn on Instagram, is to become an
                Affiliate Marketer. Just as an Instagram Influencer, an
                affiliate marketer also gets to work with various renowned
                brands. The only difference is that Influencers are more focused
                on creating awareness about a product while affiliate marketers
                focus on increasing its sales.
              </p>
              <p>
                Affiliate Marketers promote a product or service along with a
                trackable link or unique promotional code in their Instagram
                post or stories and if someone makes a purchase through that
                link or promo code, they earn a commission. Do not worry if you
                have less than ten thousand followers on Instagram and cannot
                use the swipe up feature in Instagram stories. You can still
                promote the link in your Instagram bio. Just add “Link In Bio”
                with every promotional post to direct people to the link.
              </p>
              <ol type="a">
                <li>
                  <strong>Choose a niche. </strong>Decide what kind of products
                  or services you would promote on your account.
                </li>
                <li>
                  <strong>Find merchants to tie ups with. </strong>You can
                  directly pitch brands or join affiliate networks like{' '}
                  <TargetLink href="https://affiliate-program.amazon.in/">
                    Amazon Associates
                  </TargetLink>
                  ,{' '}
                  <TargetLink href="https://www.vcommission.com/">
                    V Commission
                  </TargetLink>
                  ,{' '}
                  <TargetLink href="https://www.optimisemedia.com/">
                    Optimise
                  </TargetLink>
                  ,{' '}
                  <TargetLink href="https://www.hostgator.in/affiliates">
                    HostGator Affiliate Program
                  </TargetLink>{' '}
                  for collaboration.
                </li>
                <li>
                  <strong>Be creative while promoting. </strong>
                  Make sure you do not annoy your followers as affiliate posts
                  are sometimes confused with spam posts. Add a specific
                  hashtags like #ad #promotion or hashtags preferred by the
                  brand in the caption to let people know it’s a promotional
                  post.
                </li>
              </ol>
            </li>
            <li>
              <h4 id="become-an-entrepreneur">Become An Entrepreneur</h4>
              <p>
                Start your own online business and promote it on Instagram. This
                third strategy could be a difficult one but has a lot of
                potential to help you earn money through Instagram. If you
                already own a business, adding Instagram to your marketing
                strategy could be the best decision. You can sell every kind of
                product or service as a variety of audience is present on
                Instagram: from nerds to fashionistas, from athletes to
                investors.{' '}
              </p>
              <p>
                Now-a-days, selling several items on Instagram or other social
                media platforms is also possible with the help of e-commerce
                platforms like{' '}
                <TargetLink href="https://www.shopify.in/">Shopify</TargetLink>.
                Shopify has a shopping integration feature for Instagram that
                enables you to use product tags and stickers for your product
                posts, which allows the audience to view product details. To use
                it, you will have to switch your Instagram account to business
                or professional creators’ mode and have a Facebook page, and an
                approved Facebook shop.
              </p>
              <p>
                For further reading, you can check out our blog{' '}
                <TargetLink href="https://we3academy.com/blog/digital-marketing/content-strategy-social-media">
                  “Content Strategy For Instagram, Facebook, Twitter, &amp;
                  LinkedIn”
                </TargetLink>{' '}
                to know about social platforms and how to market businesses
                online.{' '}
              </p>
            </li>
          </ol>
          <p>
            We hope this article will help you to leverage your Instagram for
            earning money. Before you incorporate any of the above strategies,
            make sure to have a well planned and consistent Instagram grid. You
            can check out our blog{' '}
            <TargetLink href="https://we3academy.com/blog/digital-marketing/10-creative-instagram-grid-layouts">
              “10 Creative Instagram Grid Layout”
            </TargetLink>{' '}
            to know what an Instagram grid is and the types of grid patterns you
            can have to attract potential audience.
          </p>
          <p>
            To understand Influencer Marketing &amp; Affiliate Marketing in
            depth you could check out details of our upcoming workshops on
            Influencer Marketing and Affiliate Marketing.
          </p>
        </div>
      )
    }
  },
  development: {
    'what-are-coding-bootcamps': {
      title: 'What are Coding Bootcamps?',
      seo: {
        description:
          'A coding bootcamp is an intensive full-time or part-time training program where students learn programming skills and coding tools that are popular in the industry and that employers are looking for.',
        keywords:
          'WE3 Academy, WE3, what are coding bootcamps, tech blog, technology blog, coding bootcamp, blog, coding bootcamps, dev bootcamp, learn to code, tech enthusiast, coding blog, programming, programming skills, learn programming, the web developer bootcamp, technology blogs, web developer bootcamp, web development blog, programming bootcamp, full stack development bootcamp, what is a coding bootcamp, what is bootcamp coding, what is a programming bootcamp'
      },
      img: codingBootcampsImg,
      imgAlt: 'WE3 Academy | Coding Bootcamp in Mumbai',
      // author: "Rasika Pawar",
      date: 'Friday, July 26th 2019',
      fullDate: new Date(2019, 6, 26).toISOString(),
      tldr: (
        <span>
          A coding bootcamp is an intensive{' '}
          <a
            href="https://we3academy.com/full-time/web-dev"
            target="_blank"
            rel="noopener noreferrer"
          >
            full-time
          </a>{' '}
          or{' '}
          <a
            href="https://we3academy.com/part-time/web-dev"
            target="_blank"
            rel="noopener noreferrer"
          >
            part-time
          </a>{' '}
          training program where students learn programming skills and coding
          tools that are popular in the industry and that employers are looking
          for.
        </span>
      ),
      text: (
        <div>
          <p>
            Over the past few years, Coding Bootcamps have gained a lot of
            traction. Pursuing a degree for 3-4 years is not the only path to
            learn how to code and become a developer. There are tons of free
            online resources and tutorials available and every year more
            companies are changing their hiring policies to not have a computer
            science degree as a requirement. You can read more about{' '}
            <a
              href="https://we3academy.com/blog/development/online-resources-vs-coding-bootcamps"
              target="_blank"
              rel="noopener noreferrer"
            >
              how bootcamps are compared with these free online resources
            </a>
            . With practical based curriculum, bootcamps help an individual to
            develop potential skills needed to think like a developer and become
            a professional programmer.
          </p>
          <p>
            You might be wondering what coding bootcamps are or{' '}
            <a href="#why-are-coding-bootcamps-important">
              why are they important
            </a>{' '}
            and what is the eligibility criteria for joining one? This article
            will provide the answers for all of those questions.
          </p>
          <p>
            A coding bootcamp is an intensive full-time or part-time training
            program where students learn programming skills and coding tools
            that are popular in the industry and that employers are looking for.{' '}
          </p>
          <p>
            The first bootcamp was conducted in 2011. Bootcamp courses focus on
            the important aspects of coding and teach programming skills which
            enable one to build entire applications with the latest tools.
            Bootcamp students with guided support can learn to code faster and
            land on a well paid job or start their own business.
          </p>
          <h3 id="why-are-coding-bootcamps-important">
            Why are coding bootcamps important?
          </h3>
          <ol>
            <li>
              <h4>Gain Professional Skills Quickly</h4>
              <p>
                The
                <a
                  href="https://we3academy.com/full-time/web-dev"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  course structure
                </a>
                of a coding bootcamp is practical-based and the average time
                period is 12-24 weeks which is considerably less than the three
                years spent on a degree. Bootcamps consist of an intensive
                coding schedule usually from Monday - Friday with roughly 10+
                hours a day and often students have some work on Saturday and
                Sunday. It’s a big commitment but the amount of practical
                learning that is packed into a condensed period of time makes
                bootcamps quite appealing.
              </p>
            </li>
            <li>
              <h4>Raise Your Income and Get Your Dream Job</h4>
              <p>
                Having real-world programming skills can help coding bootcamp
                graduates get the job of their dreams. There is a difference
                between the paychecks of a graduate who was a complete beginner
                before enrolling for the course and an IT professional who
                enrolled to upgrade his / her skills. From our own experience,
                students who graduate from bootcamps generally know the latest
                trends and tools which enable them to land a job quicker since
                they can relate with the developers in the industry.
              </p>
            </li>
            <li>
              <h4>Be Independent And Build Your Own Products</h4>
              <p>
                Coding bootcamp experience makes you capable of building your
                own web-application and products. With the knowledge of
                programming languages and the latest technologies you gain
                during the course, you can design a career for yourself. You can
                work on a startup idea or become a freelancer to consult other
                companies projects.
              </p>
            </li>
            <li>
              <h4>Get Professional Guidance And Support</h4>
              <p>
                The instructors and mentors at coding bootcamps are industry
                professionals unlike most university professors. They guide you
                at every stage and prepare you for the challenges of the product
                design and development world. They enable you to think like
                developers in real-world situations and help you emerge as a
                qualified developer.
              </p>
            </li>
            <li>
              <h4>Work In A Team</h4>
              <p>
                Working with your fellow classmates helps you become a team
                player as you learn to collaborate with others to accomplish a
                common goal. You get to learn from each others perspective and
                expand your knowledge. Discussing a concept with team mates and
                explaining things to someone who may need help understanding,
                will help you to incorporate what you’ve learned.
              </p>
            </li>
            <li>
              <h4>Real-World Problems</h4>
              <p>
                In a coding bootcamp, you experience a real-working environment
                working at close to real-world problems. You deal with the same
                work pressure as a professional and develop products using the
                tools and tech stack used in the industry. The work-loads are
                large, schedules are quite busy and there’s a big learning
                curve. By the end of the course,
                <a
                  href="https://we3academy.com/blog/development/how-bootcamps-boost-personality"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  you are ready to face on-job challenges
                </a>
                .
              </p>
            </li>
          </ol>
          <h3>Who can join a Coding Bootcamp?</h3>
          <ul>
            <li>
              <h4>Recent Graduates / College Students</h4>
              <p>
                If you have graduated from college or are pursuing any degree,
                you can apply for a coding bootcamp. It will give you the
                fundamental real-world skills to launch a career as a web
                developer or start your own business, if you have an idea you
                want to execute.
              </p>
            </li>
            <li>
              <h4>Working IT Professionals / Developers</h4>
              <p>
                IT professionals / Developers who need to upgrade their skills,
                learn different skill sets or switch career paths may also opt
                for the bootcamp. It will help you enhance your skills and
                enable you to fulfill your career goals.
              </p>
            </li>
            <li>
              <h4>Entrepreneurs</h4>
              <p>
                If you’re thinking of launching a tech company or have an idea
                you want to build, then going to a coding bootcamp will help you
                acquire the technical skills required to build an MVP or manage
                a technical team and make great contacts in the process.
              </p>
            </li>
            <li>
              <h4>Self-taught Programmers / Tech Enthusiasts</h4>
              <p>
                A coding bootcamp will help build your fundamentals and skills.
                If you are pursuing a different degree but interested in
                becoming a developer, or you are someone who is interested in
                learning how to create your own applications from scratch but
                need the guidance of mentors and instructors.
              </p>
            </li>
          </ul>
        </div>
      )
    },
    'how-bootcamps-boost-personality': {
      title: 'How Coding Bootcamps Boost Your Personality?',
      seo: {
        description:
          'Coding Bootcamps not only help you to become a qualified developer but also develops your personality in many ways. They help make you independent, allow you to accept criticism, enable you to be a better team player and keep you accountable.',
        keywords:
          'WE3 Academy, WE3, how coding bootcamps boost your personality, programming blogs, web development blogs, tech blog, technology blog, coding bootcamp, blog, coding bootcamps, dev bootcamp, learn to code, tech enthusiast, coding blog, programming, programming skills, learn programming, the web developer bootcamp, technology blogs, web developer bootcamp, web development blog, programming bootcamp, full stack development bootcamp, boost personality, boosting personality, qualified developer, '
      },
      img: boostPersonalityImg,
      imgAlt: 'WE3 Academy | How Coding Bootcamps Boost Your Personality?',
      // author: "Rasika Pawar",
      date: 'Thursday, August 01st 2019',
      fullDate: new Date(2019, 7, 1).toISOString(),
      tldr: (
        <span>
          Coding Bootcamps not only help you to become a qualified developer but
          also develops your personality in many ways. They help make you{' '}
          <a href="#independent">independent</a>, allow you to{' '}
          <a href="#accept-criticism">accept criticism</a>, enable you to be a
          better <a href="#team-player">team player</a> and keep you{' '}
          <a href="#accountable">accountable</a>.
        </span>
      ),
      text: (
        <div>
          <p>
            By signing up for a{' '}
            <a
              href="https://we3academy.com/full-time/web-dev"
              target="_blank"
              rel="noopener noreferrer"
            >
              coding bootcamp
            </a>{' '}
            you take a first step towards becoming a qualified developer. You
            learn new technologies and improve your skills in every session.
            While developing these skills, you also evolve as an individual
            everyday in some ways. Wonder how? Here we have listed 6 personality
            traits that you are likely to adapt at coding bootcamp -
          </p>
          <ol>
            <li>
              <h4>Balanced</h4>
              <p>
                In most of the coding bootcamps you are expected to work for
                10-12 hours a day. Over time you learn to balance your personal
                life while running on such a intensed routine. You learn how to
                prioritize.
              </p>
            </li>
            <li>
              <h4 id="team-player">Team Player</h4>
              <p>
                Coding bootcamps usually involve individual as well as group
                assignments and projects. These collaborations help you learn to
                coordinate and work effectively with team members. You learn to
                welcome and appreciate each others ideas and opinions. This
                widens your knowledge, shows you different perspectives and
                makes you a great team player.
              </p>
            </li>
            <li>
              <h4 id="independent">Independent</h4>
              <p>
                By the end of a good coding bootcamp you become capable of
                building your own web applications and products. With the
                improved knowledge and skills, you can choose a career for
                yourself as an entrepreneur or a freelancer or consultant for
                product development projects.
              </p>
            </li>
            <li>
              <h4 id="accept-criticism">Accepting Criticism</h4>
              <p>
                At coding bootcamps, you get guidance from industry
                professionals. They give you constant feedback for your work
                which could be positive and sometimes negative. At such times,
                it’s best to keep your ego aside, ask and seek to understand
                what the problems are, and resolve them. This enables you to
                perform better each time and improves your skill set.
              </p>
            </li>
            <li>
              <h4 id="accountable">Risk Bearer</h4>
              <p>
                During the course, you are supposed to take those everyday risks
                of programming, like breaking what you’ve built, dealing with
                bugs, trying a new framework, all on a tight deadline, which
                ultimately helps you to be accountable for your own decisions.
              </p>
            </li>
            <li>
              <h4>Knowledgeable</h4>
              <p>
                Coding bootcamps help you upgrade your professional skills and
                enable you to know exactly what areas of your knowledge need
                further improvement. They make you think like developers and
                most importantly teach you how to learn a new language,
                framework or tool.
              </p>
            </li>
          </ol>
          <p>
            Being a coding bootcamp graduate is a big deal and you should be
            proud of your accomplishments. You don’t just become a developer but
            can gain experience and a lot of personality traits.
          </p>
        </div>
      )
    },
    'effective-peer-mentor': {
      title: 'How To Be An Effective Peer Mentor?',
      seo: {
        description:
          'Peer Mentors are more experienced students who act as a role model for new students. To be a good mentor then you need to be supportive and set a positive example to your mentee. Read our blog to learn a few ways to become an effective peer mentor.',
        keywords:
          'WE3 Academy, WE3, how to be an effective peer mentor, peer mentor, peer mentors, mentor, mentors, mentorship, mentee, supportive, student peer, mentoring, peer mentoring, peer to peer, peers, a mentor, peer mentor program, mentorship program, mentor program, student peer mentor, mentor and mentee, mentor and mentee relation,'
      },
      img: peerMentorImg,
      imgAlt: 'WE3 Academy | How To Be An Effective Peer Mentor',
      // author: "Rasika Pawar",
      date: 'Friday, August 09th 2019',
      fullDate: new Date(2019, 7, 9).toISOString(),
      tldr: (
        <span>
          Peer Mentors are more experienced students who act as a role model for
          new students. To be a good mentor then you need to be supportive and
          set a positive example to your mentee. Read our blog to learn a{' '}
          <a href="#good-mentor">few ways to become an effective peer mentor</a>
          .
        </span>
      ),
      text: (
        <div>
          <p>
            Playing the role of a <a href="#peer-mentors">peer mentor</a> can be
            difficult at times, but definitely exciting and fun. Being a
            peer-mentor you are in the same-boat with your mentee and aware of
            the dilemma newbies face. You understand them and they will relate
            to you, so can give them better advice and make them comfortable.
          </p>
          <h3 id="peer-mentors">Who are Peer Mentors?</h3>
          <p>
            Peer Mentors are not instructors or teachers but role models for new
            students. They are more experienced students who serve as leaders
            and supportive peer to new students by transferring knowledge and
            promoting best practices to them.
          </p>
          <p>
            <a
              href="https://owlcation.com/academia/How-To-Be-A-Great-Peer-Mentor"
              target="_blank"
              rel="noopener noreferrer"
            >
              Governor's Academy for Engineering Studies says:
            </a>
          </p>
          <p>
            “A peer mentor is a role model who provides leadership to new
            students by establishing and maintaining an ongoing connection. He
            or she is a trusted source of information, support and
            encouragement.”
          </p>

          <h3>How does mentor-mentee relation work?</h3>
          <p>
            Establishing a successful mentor-mentee relationship requires work,
            trust, and commitment from both sides. Peer mentoring comes with
            several responsibilities. As a peer mentor you are assumed to
            understand the personality, learning style, and goals of your mentee
            and a mentee is supposed to trust his / her mentor. A{' '}
            <a href="#qualities-peer-mentor">good peer mentor</a> always
            encourages, supports, and helps mentee in every situation. Keeping
            your mentee’s best interest in mind you should render solutions /
            advice to them.
          </p>
          <p>
            <strong>Tip for mentors:</strong> If your mentee hesitates to ask
            questions, make them feel comfortable, encourage them to ask
            questions and spend some time with them to clear their doubts.
          </p>

          <h3 id="qualities-peer-mentor">Qualities of a good mentor</h3>
          <p>
            A good peer mentor should have strong interpersonal and
            communication skills. With a positive can-do attitude, they have the
            willingness to share their knowledge and experience with others.
          </p>

          <h3 id="good-mentor">5 Ways To Be An Effective Peer Mentor</h3>
          <p>
            We have listed down 5 ways that can help an individual emerge as an
            effective peer mentor:
          </p>
          <ol>
            <li>
              <h4>Maintain Transparency In Your Relation</h4>
              <p>
                In the beginning, introduce yourself and the mentoring process
                to your mentee. Explain your role and how you plan to help them.
                Make sure to clear their every doubt and take initiative if they
                hesitate. Make sure that they feel comfortable and understand
                their needs, wants, goals, and ideas. Ask them about their
                background and current situation. You will need it in order to
                help them.
              </p>
            </li>
            <li>
              <h4>Provide Trusted Information</h4>
              <p>
                If you want your mentee to trust you, be truthful to them.
                Always provide them accurate information to the best of your
                knowledge and give them your honest opinions and suggestions.
                Create an environment of trust.
              </p>
            </li>
            <li>
              <h4>Be Supportive But Also Critical</h4>
              <p>
                Listen to your mentee’s opinions and problems. Support and
                encourage them at every stage but also be a critique of their
                actions. Tell them when they are wrong but also remember to
                celebrate their achievements.
              </p>
            </li>
            <li>
              <h4>Let Them Make Their Own Decisions</h4>
              <p>
                Guide them to find solutions but do not make any decisions for
                them. It’s found that people learn more from their own mistakes
                and solutions. If you tell them the answer, it won’t benefit
                them as much as it will if they arrive at the answer on their
                own. Let them make their own decisions and take a stand for
                their actions.
              </p>
            </li>
            <li>
              <h4>Lead by example</h4>
              <p>
                Your mentees are likely to follow your lead and adapt your style
                into their behavior. As a mentor you are supposed to be aware of
                how you behave in front of them. You need to set a positive
                example for your mentee.
              </p>
            </li>
          </ol>
          <p>
            To be a <a href="#qualities-peer-mentor">great peer mentor</a>,
            think about what kind of mentor you would like to have and then act.
            Put yourself in their shoes. Remember there was a time when you were
            new too.
          </p>
        </div>
      )
    },
    'online-resources-vs-coding-bootcamps': {
      title: 'Learn From Online Resources Or Opt For a Bootcamp?',
      seo: {
        title: 'Online Resources Or Coding Bootcamp',
        description:
          'Online Resources Coding Bootcamp both help you learn the practical skills necessary to become a professional developer. It could be difficult to decide on one. This blog seeks to answer some of your questions and compare online resources to in-class bootcamps.',
        keywords:
          'WE3 Academy, WE3, learn from online resources or opt for a bootcamp, learn from online resources, online resources, online sessions, in class training, online training, online training sessions, training sessions, online programming resources, coding bootcamp, dev bootcamp, tech bootcamp, programming bootcamp, '
      },
      img: onlineVsInPersonImg,
      imgAlt: 'WE3 Academy | Online Resources Vs Bootcamps',
      // author: "Rasika Pawar",
      date: 'Friday, August 16th 2019',
      fullDate: new Date(2019, 7, 16).toISOString(),
      tldr: (
        <span>
          Online Resources &amp; Coding Bootcamp both help you learn the
          practical skills necessary to become a professional developer. It
          could be difficult to decide on one. This blog seeks to answer some of
          your questions and compare{' '}
          <TargetLink href="https://we3academy.com/full-time/web-dev">
            online resources to in-class bootcamps.
          </TargetLink>
        </span>
      ),
      text: (
        <div>
          <p>
            Using Online Resources or joining a Coding Bootcamp will help you
            improve your coding skills and get{' '}
            <TargetLink href="https://we3academy.com/">
              practical experience
            </TargetLink>
            . The question is which one to opt for and the answer depends
            heavily on your use case and why you want to learn to code. In this
            blog post, we aim to compare learning from{' '}
            <a href="#online-resources">online resources</a> &amp;{' '}
            <a href="#coding-bootcamps">coding bootcamps</a> which may help you
            choose the right one for you -
          </p>

          <h3 id="online-resources">Online Resources</h3>
          <p>
            There are tons of online resources available on the internet, from
            the countless tutorial videos and channels you find on YouTube to
            Massive Online Open Course (MOOC) websites like{' '}
            <a
              href="https://www.udacity.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Udacity
            </a>
            ,{' '}
            <a
              href="https://www.udemy.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Udemy
            </a>
            ,{' '}
            <a
              href="https://www.edx.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              EdX
            </a>{' '}
            and even non-profits like{' '}
            <a
              href="https://www.freecodecamp.org/"
              target="_blank"
              rel="noopener noreferrer"
            >
              freeCodeCamp
            </a>
            . Taking up an online course or watching video tutorials could be
            your very first step to developing your coding skills.
          </p>
          <h4>Pros</h4>
          <ul>
            <li>
              <p>
                <h5>Flexibility -</h5>The main advantage of online lessons is
                that you can study at anytime and anywhere as per your
                convenience. It’s possible for you to have a balance between
                your personal life and learning new skills.
              </p>
            </li>
            <li>
              <p>
                <h5>Affordable - </h5>Most of these online resources are
                available for free while some of them needs subscription fees
                which are usually quite affordable.
              </p>
            </li>
            <li>
              <p>
                <h5>Pay For What You Need - </h5>Here, you get to choose what
                you would like to learn and pay for the same. This way you can
                focus more on what you like.
              </p>
            </li>
          </ul>
          <h4>Cons</h4>
          <ul>
            <li>
              <p>
                <h5>Too Many Choices - </h5>There are usually so many courses
                and videos to pick from which is likely to cause confusion.
              </p>
            </li>
            <li>
              <p>
                <h5>Lack of Immediate Feedback - </h5>With the help of online
                lessons you may build your own products but you may not get
                immediate or proper feedback on it. You may not always find a
                mentor or instructor to be around to ask a question or help
                point you in the right direction when a question arises.
              </p>
            </li>
            <li>
              <p>
                <h5>Less Social Interaction - </h5>A big disadvantage is the
                absence of interactive element when you take online lessons,
                especially for tutorials. You miss out on the fun in making new
                friends, building something in a group, getting to know your
                peers and gaining guidance and mentorship from the instructors.
              </p>
            </li>
            <li>
              <p>
                <h5>Distractions - </h5>As there’s no location barrier, external
                factors may distract you while learning, especially if you're
                learning at home and are not used to doing it.
              </p>
            </li>
          </ul>

          <h3 id="coding-bootcamps">In-Person Bootcamps</h3>
          <p>
            In-person coding bootcamp are usually 12-24 week long intensive
            programs that train you with the practical skills necessary to
            become a qualified web developer or build and launch your own
            product. With in-person teaching sessions and practical assignments
            you are able to build your own web apps and products from scratch.
          </p>
          <h4>Pros</h4>
          <ul>
            <li>
              <p>
                <h5>Career Assistance - </h5>Coding Bootcamps help you to make
                the right connections which could get you a job of your dreams.
                Most bootcamps also provide career guidance and help with your
                resume and interview preparation. If you want to launch your own
                startup or products, they may help you get investors and
                resources.
              </p>
            </li>
            <li>
              <p>
                <h5>Professional Guidance and Support - </h5>The instructors and
                mentors at coding bootcamps are industry professionals. They
                guide you at every stage and prepare you for the challenges of
                the product design and development world. You usually get
                immediate feedback which helps you to improvise your skills.
              </p>
            </li>
            <li>
              <p>
                <h5>Social Interaction - </h5>In a coding bootcamp, you get to
                collaborate with your fellow classmates for assignments and
                projects. By working with your peers, you learn each other’s
                perspectives and it helps expand your knowledge. You make new
                friends and contacts which may help you in future.
              </p>
            </li>
            <li>
              <p>
                <h5>Experience Real-working environment - </h5>You deal with
                work pressure similar to that as a professional and develop
                products using the latest tools and technologies used by
                professionals. You face huge work-loads and run on insane
                schedules. By the end of the course, you are ready to face the
                challenges of real-world projects.
              </p>
            </li>
          </ul>
          <h4>Cons</h4>
          <ul>
            <li>
              <p>
                <h5>Schedule -</h5>You have to run on intensive schedules and
                deal with competitive environment at coding bootcamp which might
                be a little exhausting. Remember no learning is possible without
                an extensive brain-storming sessions.
              </p>
            </li>
            <li>
              <p>
                <h5>Cost -</h5>When compared with online resources, bootcamps
                are more expensive. But worth it if you are looking for a good
                environment to learn in while being supported and mentored by
                developers with like-minded peers.
              </p>
            </li>
          </ul>
          <p style={{ marginTop: '60px' }}>
            What you pick is eventually a personal choice based on your current
            circumstances and preferences but we hope this blog post helped give
            you some perspective.
          </p>
        </div>
      )
    }
    // 5: {
    //     title: "Which programming languages should I learn?",
    //     img: blog5,
    //     imgAlt: "Something Interesting",
    //     author: "John Doe",
    //     date: "Thursday, April 04th 2019",
    //     tldr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae massa maximus, aliquet ipsum quis",
    //     text: ["Which programming language should I learn and why? If you are thinking about learning a programming language, or even want to become a (web) developer, there are basically two big, interrelated, hurdles that you need to overcome. The first is, which language should I…",
    //            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae massa maximus, aliquet ipsum quis, rhoncus mi. Pellentesque sit amet molestie arcu, eu viverra enim. Suspendisse potenti. Donec non nisl nec ante venenatis placerat sit amet nec felis. Sed fermentum molestie quam id aliquet. Integer sed mollis magna. Aliquam ornare malesuada enim lacinia tempus. Vivamus a sodales eros.",
    //            "Donec vitae gravida dolor. Ut ultricies ligula est, ut eleifend purus mollis et. Vestibulum eget justo et turpis consectetur egestas in eu purus. Vivamus ultrices nibh et mi sagittis imperdiet. Maecenas non felis magna. Sed vitae magna risus. Quisque eu porttitor ipsum, id convallis tellus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. In nulla neque, tempus vel dolor vel, sagittis feugiat lorem. Praesent eros lorem, tempor in dolor nec, aliquam efficitur mauris. In luctus sem ex, quis consectetur neque malesuada a. Sed a nisi eget felis finibus blandit. Fusce feugiat sed felis ac sodales. Donec viverra ante est, non mollis magna tristique a",
    //            "Aenean quis vehicula ante, eu vestibulum felis. Sed id turpis felis. Morbi dapibus felis consequat, lacinia velit in, auctor neque. Duis ac neque elit. Phasellus vel velit nisl. Mauris mauris augue, ornare at elit eget, consectetur posuere est. Praesent vitae sodales massa. Aenean at ligula sed lorem finibus luctus ut ut arcu. Ut risus nunc, pellentesque vitae pellentesque molestie, porta ac lectus. Fusce mollis vehicula laoreet. Morbi maximus elit quis tempor dictum. Ut sit amet tincidunt nunc. Fusce venenatis lectus eu eros blandit, ullamcorper feugiat velit tincidunt.",
    //            "Nam facilisis bibendum auctor. Morbi tempus ligula ac ante egestas, eget malesuada est mollis. Praesent iaculis ipsum venenatis sodales tristique. In vitae justo a odio vestibulum mollis nec nec nisl. Vestibulum non posuere nibh, sed laoreet nulla. Nam malesuada metus sit amet orci ornare ornare. Nunc elit velit, blandit sit amet augue quis, tristique feugiat velit. Ut ac malesuada ante. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aliquam erat volutpat. Nullam et elit ut arcu pharetra mollis. Aliquam in sollicitudin dui. Maecenas tempus arcu in tellus fringilla, non finibus neque ullamcorper. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //            "Donec iaculis tortor ante, non finibus dolor cursus nec. Donec dapibus, dolor in ultrices fermentum, urna leo pulvinar mi, sed condimentum ipsum purus vitae leo. In vel pellentesque neque, cursus suscipit ex. Nam vel neque at justo bibendum hendrerit. Phasellus ut fringilla ante, nec blandit enim. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris nec pharetra urna, imperdiet gravida ante. Nunc convallis erat purus, accumsan accumsan lorem fermentum id. Donec ac massa sed nisl imperdiet consequat. Sed quam ante, tempor eu metus at, ultrices suscipit lectus. Maecenas nec mattis orci, sit amet dictum odio. Pellentesque volutpat non nisl ac dictum. Fusce viverra nulla neque. Curabitur sollicitudin sollicitudin sapien in ornare. Aliquam id luctus velit."
    //           ]
    // },
    // 6: {
    //     title: "Which programming languages should I learn?",
    //     img: blog6,
    //     imgAlt: "Something Interesting",
    //     author: "John Doe",
    //     date: "Thursday, April 04th 2019",
    //     tldr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae massa maximus, aliquet ipsum quis",
    //     text: ["Which programming language should I learn and why? If you are thinking about learning a programming language, or even want to become a (web) developer, there are basically two big, interrelated, hurdles that you need to overcome. The first is, which language should I…",
    //            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae massa maximus, aliquet ipsum quis, rhoncus mi. Pellentesque sit amet molestie arcu, eu viverra enim. Suspendisse potenti. Donec non nisl nec ante venenatis placerat sit amet nec felis. Sed fermentum molestie quam id aliquet. Integer sed mollis magna. Aliquam ornare malesuada enim lacinia tempus. Vivamus a sodales eros.",
    //            "Donec vitae gravida dolor. Ut ultricies ligula est, ut eleifend purus mollis et. Vestibulum eget justo et turpis consectetur egestas in eu purus. Vivamus ultrices nibh et mi sagittis imperdiet. Maecenas non felis magna. Sed vitae magna risus. Quisque eu porttitor ipsum, id convallis tellus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. In nulla neque, tempus vel dolor vel, sagittis feugiat lorem. Praesent eros lorem, tempor in dolor nec, aliquam efficitur mauris. In luctus sem ex, quis consectetur neque malesuada a. Sed a nisi eget felis finibus blandit. Fusce feugiat sed felis ac sodales. Donec viverra ante est, non mollis magna tristique a",
    //            "Aenean quis vehicula ante, eu vestibulum felis. Sed id turpis felis. Morbi dapibus felis consequat, lacinia velit in, auctor neque. Duis ac neque elit. Phasellus vel velit nisl. Mauris mauris augue, ornare at elit eget, consectetur posuere est. Praesent vitae sodales massa. Aenean at ligula sed lorem finibus luctus ut ut arcu. Ut risus nunc, pellentesque vitae pellentesque molestie, porta ac lectus. Fusce mollis vehicula laoreet. Morbi maximus elit quis tempor dictum. Ut sit amet tincidunt nunc. Fusce venenatis lectus eu eros blandit, ullamcorper feugiat velit tincidunt.",
    //            "Nam facilisis bibendum auctor. Morbi tempus ligula ac ante egestas, eget malesuada est mollis. Praesent iaculis ipsum venenatis sodales tristique. In vitae justo a odio vestibulum mollis nec nec nisl. Vestibulum non posuere nibh, sed laoreet nulla. Nam malesuada metus sit amet orci ornare ornare. Nunc elit velit, blandit sit amet augue quis, tristique feugiat velit. Ut ac malesuada ante. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aliquam erat volutpat. Nullam et elit ut arcu pharetra mollis. Aliquam in sollicitudin dui. Maecenas tempus arcu in tellus fringilla, non finibus neque ullamcorper. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //            "Donec iaculis tortor ante, non finibus dolor cursus nec. Donec dapibus, dolor in ultrices fermentum, urna leo pulvinar mi, sed condimentum ipsum purus vitae leo. In vel pellentesque neque, cursus suscipit ex. Nam vel neque at justo bibendum hendrerit. Phasellus ut fringilla ante, nec blandit enim. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris nec pharetra urna, imperdiet gravida ante. Nunc convallis erat purus, accumsan accumsan lorem fermentum id. Donec ac massa sed nisl imperdiet consequat. Sed quam ante, tempor eu metus at, ultrices suscipit lectus. Maecenas nec mattis orci, sit amet dictum odio. Pellentesque volutpat non nisl ac dictum. Fusce viverra nulla neque. Curabitur sollicitudin sollicitudin sapien in ornare. Aliquam id luctus velit."
    //           ]
    // },
    // 7: {
    //     title: "Which programming languages should I learn?",
    //     img: blog7,
    //     imgAlt: "Something Interesting",
    //     author: "John Doe",
    //     date: "Thursday, April 04th 2019",
    //     tldr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae massa maximus, aliquet ipsum quis",
    //     text: ["Which programming language should I learn and why? If you are thinking about learning a programming language, or even want to become a (web) developer, there are basically two big, interrelated, hurdles that you need to overcome. The first is, which language should I…",
    //            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Phasellus vitae massa maximus, aliquet ipsum quis, rhoncus mi. Pellentesque sit amet molestie arcu, eu viverra enim. Suspendisse potenti. Donec non nisl nec ante venenatis placerat sit amet nec felis. Sed fermentum molestie quam id aliquet. Integer sed mollis magna. Aliquam ornare malesuada enim lacinia tempus. Vivamus a sodales eros.",
    //            "Donec vitae gravida dolor. Ut ultricies ligula est, ut eleifend purus mollis et. Vestibulum eget justo et turpis consectetur egestas in eu purus. Vivamus ultrices nibh et mi sagittis imperdiet. Maecenas non felis magna. Sed vitae magna risus. Quisque eu porttitor ipsum, id convallis tellus. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. In nulla neque, tempus vel dolor vel, sagittis feugiat lorem. Praesent eros lorem, tempor in dolor nec, aliquam efficitur mauris. In luctus sem ex, quis consectetur neque malesuada a. Sed a nisi eget felis finibus blandit. Fusce feugiat sed felis ac sodales. Donec viverra ante est, non mollis magna tristique a",
    //            "Aenean quis vehicula ante, eu vestibulum felis. Sed id turpis felis. Morbi dapibus felis consequat, lacinia velit in, auctor neque. Duis ac neque elit. Phasellus vel velit nisl. Mauris mauris augue, ornare at elit eget, consectetur posuere est. Praesent vitae sodales massa. Aenean at ligula sed lorem finibus luctus ut ut arcu. Ut risus nunc, pellentesque vitae pellentesque molestie, porta ac lectus. Fusce mollis vehicula laoreet. Morbi maximus elit quis tempor dictum. Ut sit amet tincidunt nunc. Fusce venenatis lectus eu eros blandit, ullamcorper feugiat velit tincidunt.",
    //            "Nam facilisis bibendum auctor. Morbi tempus ligula ac ante egestas, eget malesuada est mollis. Praesent iaculis ipsum venenatis sodales tristique. In vitae justo a odio vestibulum mollis nec nec nisl. Vestibulum non posuere nibh, sed laoreet nulla. Nam malesuada metus sit amet orci ornare ornare. Nunc elit velit, blandit sit amet augue quis, tristique feugiat velit. Ut ac malesuada ante. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Aliquam erat volutpat. Nullam et elit ut arcu pharetra mollis. Aliquam in sollicitudin dui. Maecenas tempus arcu in tellus fringilla, non finibus neque ullamcorper. Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
    //            "Donec iaculis tortor ante, non finibus dolor cursus nec. Donec dapibus, dolor in ultrices fermentum, urna leo pulvinar mi, sed condimentum ipsum purus vitae leo. In vel pellentesque neque, cursus suscipit ex. Nam vel neque at justo bibendum hendrerit. Phasellus ut fringilla ante, nec blandit enim. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Mauris nec pharetra urna, imperdiet gravida ante. Nunc convallis erat purus, accumsan accumsan lorem fermentum id. Donec ac massa sed nisl imperdiet consequat. Sed quam ante, tempor eu metus at, ultrices suscipit lectus. Maecenas nec mattis orci, sit amet dictum odio. Pellentesque volutpat non nisl ac dictum. Fusce viverra nulla neque. Curabitur sollicitudin sollicitudin sapien in ornare. Aliquam id luctus velit."
    //           ]
    // }
  }
};

export {
  _blogData as blogData,
  _featured as featured,
  _blogTypes as blogTypes
};
